export default __webpack_public_path__ + "static/media/celebrations.2a1f1507.svg";